<template>
  <VTooltip :popper-class="props.theme ? `v-popper--color-${props.theme}` : undefined" :aria-id="ariaId">
    <slot name="content">
      <div class="group/tooltip relative flex cursor-pointer text-text-strong" tabindex="0">
        <Icon class="size-5 transition-opacity group-hover/tooltip:opacity-0" name="info" />
        <Icon name="info-filled" class="absolute inset-0 size-5 opacity-0 transition-opacity group-hover/tooltip:opacity-100" />
      </div>
    </slot>

    <template #popper>
      <slot />
    </template>
  </VTooltip>
</template>

<script setup lang="ts">
import { Tooltip as VTooltip, options as FloatingVueOptions } from 'floating-vue'
import Icon from '~/components/icon/Icon.vue'

FloatingVueOptions.themes.tooltip.triggers = ['hover', 'focus', 'touch', 'click']

const ariaId = useId()

const props = withDefaults(
  defineProps<{
    theme?: string
  }>(),
  {
    theme: '',
  }
)
</script>

<style lang="scss">
.v-popper--theme-tooltip {
  .v-popper__arrow-container {
    @apply hidden;
  }

  .v-popper__inner {
    @apply max-w-80 rounded-2xl border border-border-active bg-background-light-strong p-4 text-base font-normal text-text shadow-04;
  }

  &.v-popper--color-error {
    .v-popper__inner {
      @apply border border-attention-bright bg-attention-extra-light;
    }
  }
}
</style>
